import { useNavigate, useParams } from 'react-router-dom'

import { useRunLinkStructureMutation } from '@/common/api/modules/article'
import { useAnalysisHistoryDetailApi } from '@/common/api/modules/mediaAnalysis'
import { mediaAnalysisResultPath } from '@/common/app/path'
import { LinkStructureAnalysis } from '@/common/model/media/articleCreator'
import { MediaAnalysisType } from '@/common/model/media/mediaAnalysis'

import AiButton from '@/components/view/atoms/button/AiButton'

import LinkStructurePanel from '@/components/container/modules/media/analysis/LinkStructurePanel'

import MediaAnalysisResultPageBase from './MediaAnalysisResultPageBase'

// 内部リンク分析結果
const MediaAnalysisLinkStructureResultPage = () => {
  const { siteId, historyId } = useParams()
  const sid = Number(siteId)
  const navigate = useNavigate()
  // 分析中（status=analyzing）の間は2秒間隔でポーリングし、完了したら自動的に停止する
  const { data, error } = useAnalysisHistoryDetailApi(
    siteId && historyId ? { site_id: sid, history_id: Number(historyId) } : undefined,
    { refreshInterval: (latest) => (latest?.status === 'analyzing' ? 2000 : 0) }
  )

  // 再分析もバックグラウンド実行。作成された分析中レコードの詳細画面へ即遷移する
  const { trigger: reanalyze, isMutating: reanalyzing } = useRunLinkStructureMutation({
    onSuccess: (res) => {
      if (res.id != null) {
        navigate(mediaAnalysisResultPath(sid, MediaAnalysisType.LINK_STRUCTURE, res.id))
      }
    }
  })

  const analyzing = data?.status === 'analyzing'
  const analysis = (data?.result_data ?? {}) as LinkStructureAnalysis

  return (
    <MediaAnalysisResultPageBase
      type={MediaAnalysisType.LINK_STRUCTURE}
      data={data}
      error={error}
      resultError={analysis.error}
      rightNode={
        <AiButton
          size='large'
          disabled={analyzing || reanalyzing}
          onClick={() => reanalyze({ site_id: sid })}
        >
          {reanalyzing ? '再分析中...' : '再分析する'}
        </AiButton>
      }
    >
      <LinkStructurePanel siteId={sid} historyId={Number(historyId)} analysis={analysis} />
    </MediaAnalysisResultPageBase>
  )
}

export default MediaAnalysisLinkStructureResultPage
